const routes = [
  {
    path: '/company/expression_of_interest',
    name: 'CompanyExpressionOfInterest',
    component: () => import('../../views/company/expression_of_interest/List.vue')
  },
  {
    path: '/company/edit/expression_of_interest/:id',
    name: 'company_edit_expression_of_interest',
    component: () => import('../../views/company/expression_of_interest/Edit.vue')
  },
  {
    path: '/company/create/expression_of_interest',
    name: 'company_create_expression_of_interest',
    component: () => import('../../views/company/expression_of_interest/Create.vue')
  },
  {
    path: '/company/expression_of_interest/details/:id',
    name: 'CompanyExpressionOfInterest_details',
    component: () => import('../../views/company/expression_of_interest/Details.vue')
  },
  {
    path: '/company/expression_of_interest/create/category/:id',
    name: 'CompanyExpressionOfInterest_category_create',
    component: () => import('../../views/company/expression_of_interest/category/Create.vue')
  },
  {
    path: '/company/expression_of_interest/edit/category/:prequal_id/:category_id',
    name: 'CompanyExpressionOfInterest_category_edit',
    component: () => import('../../views/company/expression_of_interest/category/Edit.vue')
  },
  {
    path: '/company/expression_of_interest/category/details/:prequal_id/:category_id',
    name: 'CompanyExpressionOfInterest_category_details',
    component: () => import('../../views/company/expression_of_interest/category/Details.vue')
  },
  {
    path: '/company/expression_of_interest/duplicate/category/:prequal_id/:category_id',
    name: 'CompanyExpressionOfInterestDuplicateCategory',
    component: () => import('../../views/company/expression_of_interest/CloneCategory.vue')
  },
  {
    path: '/company/expression_of_interest/category/refresh/scores/:prequal_id/:category_id/:task_id',
    name: 'CompanyExpressionOfInterestCategoryRefreshScores',
    component: () => import('../../views/company/expression_of_interest/category/RefreshScoresProgress.vue')
  },
  {
    path: '/company/expression_of_interest/create/section/:prequal_id/:category_id',
    name: 'CompanyExpressionOfInterest_create_section',
    component: () => import('../../views/company/expression_of_interest/category/section/Create.vue')
  },
  {
    path: '/company/expression_of_interest/edit/section/:prequal_id/:category_id/:section_id',
    name: 'CompanyExpressionOfInterest_edit_section',
    component: () => import('../../views/company/expression_of_interest/category/section/Edit.vue')
  },
  {
    path: '/company/expression_of_interest/section/questions/:category_id/:section_id',
    name: 'CompanyExpressionOfInterest_section_questions',
    component: () => import('../../views/company/expression_of_interest/category/section/Questions.vue')
  },
  {
    path: '/company/expression_of_interest/create/question/:category_id/:section_id',
    name: 'CompanyExpressionOfInterest_create_question',
    component: () => import('../../views/company/expression_of_interest/category/section/CreateQuestion.vue')
  },
  {
    path: '/company/expression_of_interest/edit/question/:category_id/:section_id/:id',
    name: 'CompanyExpressionOfInterest_edit_question',
    component: () => import('../../views/company/expression_of_interest/category/section/EditQuestion.vue')
  },
  {
    path: '/company/expression_of_interest/qa/instructions/:category_id',
    name: 'CompanyExpressionOfInterest_qa_instructions',
    component: () => import('../../views/company/expression_of_interest/category/qa/AddInstructions.vue')
  },
  {
    path: '/company/expression_of_interest/evaluation/instructions/:category_id',
    name: 'CompanyExpressionOfInterest_evaluation_instructions',
    component: () => import('../../views/company/expression_of_interest/category/evaluation/AddInstructions.vue')
  },
  {
    path: '/company/expression_of_interest/conduct/qa/:category_id/:participant_id',
    name: 'CompanyExpressionOfInterest_conduct_qa',
    component: () => import('../../views/company/expression_of_interest/category/qa/ConductQa.vue')
  },
  {
    path: '/company/expression_of_interest/conduct/evaluation/:category_id/:participant_id',
    name: 'CompanyExpressionOfInterest_conduct_evaluation',
    component: () => import('../../views/company/expression_of_interest/category/evaluation/ConductEvaluation.vue')
  },
  {
    path: '/company/expression_of_interest/dd/details/:category_id',
    name: 'CompanyExpressionOfInterest_dd_details',
    component: () => import('../../views/company/expression_of_interest/category/dd/Participants.vue')
  },
  {
    path: '/company/expression_of_interest/dd/conduct/:category_id/:participant_id/:question_id',
    name: 'CompanyExpressionOfInterest_dd_conduct',
    component: () => import('../../views/company/expression_of_interest/category/dd/ConductDD.vue')
  },
  {
    path: '/company/expression_of_interest/dd/add/questions/:category_id',
    name: 'CompanyExpressionOfInterest_dd_add_questions',
    component: () => import('../../views/company/expression_of_interest/category/dd/AddDDWideQuestions.vue')
  },
  {
    path: '/company/expression_of_interest/dd/add/supplier/questions/:category_id/:participant_id',
    name: 'CompanyExpressionOfInterest_dd_add_supplier_questions',
    component: () => import('../../views/company/expression_of_interest/category/dd/AddPerSupplierQuestion.vue')
  },
  {
    path: '/company/expression_of_interest/dd/supplier/questions/:category_id/:participant_id',
    name: 'CompanyExpressionOfInterest_dd_supplier_questions',
    component: () => import('../../views/company/expression_of_interest/category/dd/SupplierQuestions.vue')
  },
  {
    path: '/company/expression_of_interest/letters/:job_id/:category_id',
    name: 'CompanyExpressionOfInterest_letters',
    component: () => import('../../views/company/expression_of_interest/category/letters/ParticipantList.vue')
  },
  {
    path: '/company/expression_of_interest/preview/award/letter/:job_id/:category_id/:supplier_id',
    name: 'CompanyExpressionOfInterest_preview_award_letter',
    component: () => import('../../views/company/expression_of_interest/category/letters/award_letter/PreviewLetter.vue')
  },
  {
    path: '/company/expression_of_interest/preview/regret/letter/:job_id/:category_id/:supplier_id',
    name: 'CompanyExpressionOfInterest_preview_regret_letter',
    component: () => import('../../views/company/expression_of_interest/category/letters/regret_letter/PreviewLetter.vue')
  },
  {
    path: '/company/expression_of_interest/category/question/upload/progress/:prequal_id/:category_id/:task_id',
    name: 'CompanyExpressionOfInterest_category_question_upload_progress',
    component: () => import('../../views/company/expression_of_interest/category/section/QuestionUploadProgress.vue')
  },
  {
    path: '/company/expression_of_interest/question/upload/progress/:prequal_id/:task_id',
    name: 'CompanyExpressionOfInterestQuestionUploadProgress',
    component: () => import('../../views/company/expression_of_interest/QuestionUploadProgress.vue')
  },
  {
    path: '/company/expression_of_interest/reports/:id',
    name: 'CompanyExpressionOfInterest_reports',
    component: () => import('../../views/company/expression_of_interest/reports/Details.vue')
  },
  {
    path: '/company/expression_of_interest/report/progress/:prequal_id/:task_id',
    name: 'CompanyExpressionOfInterestReportsProgress',
    component: () => import('../../views/company/expression_of_interest/reports/Progress.vue')
  },
  {
    path: '/company/expression_of_interest/invited/suppliers/:prequal_id/:category_id',
    name: 'CompanyExpressionOfInterest_invited_suppliers',
    component: () => import('../../views/company/expression_of_interest/category/InvitedSuppliers.vue')
  },
  {
    path: '/company/expression_of_interest/invite/system/suppliers/:prequal_id/:category_id',
    name: 'CompanyExpressionOfInterestInviteSystemSuppliers',
    component: () => import('../../views/company/expression_of_interest/category/SystemSuppliers.vue')
  },
  {
    path: '/company/expression_of_interest/letters/jobs',
    name: 'CompanyExpressionOfInterestLetterJobs',
    component: () => import('../../views/company/expression_of_interest/category/letters/LetterJobs.vue')
  },
  {
    path: '/company/expression_of_interest/letters/:job_id',
    name: 'CompanyExpressionOfInterestLetterCategories',
    component: () => import('../../views/company/expression_of_interest/category/letters/LetterCategories.vue')
  },
  {
    path: '/company/expression_of_interest/letters/success/create/:job_id',
    name: 'CompanyExpressionOfInterestLetterSuccessCreate',
    component: () => import('../../views/company/expression_of_interest/category/letters/award_letter/CreateAward.vue')
  },
  {
    path: '/company/expression_of_interest/letters/success/edit/:job_id',
    name: 'CompanyExpressionOfInterestLetterSuccessEdit',
    component: () => import('../../views/company/expression_of_interest/category/letters/award_letter/EditAwardLetter.vue')
  },
  {
    path: '/company/expression_of_interest/letters/custom/create/:job_id',
    name: 'CompanyExpressionOfInterestLetterCustomCreate',
    component: () => import('../../views/company/expression_of_interest/category/letters/custom/CreateCustom.vue')
  },
    {
    path: '/company/expression_of_interest/letters/custom/edit/:job_id',
    name: 'CompanyExpressionOfInterestLetterCustomEdit',
    component: () => import('../../views/company/expression_of_interest/category/letters/custom/EditCustomLetter.vue')
  },
  {
    path: '/company/expression_of_interest/letters/dd/create/:job_id',
    name: 'CompanyExpressionOfInterestLetterDDCreate',
    component: () => import('../../views/company/expression_of_interest/category/letters/dd_letter/CreateDD.vue')
  },
  {
    path: '/company/expression_of_interest/letters/dd/edit/:job_id',
    name: 'CompanyExpressionOfInterestLetterDDEdit',
    component: () => import('../../views/company/expression_of_interest/category/letters/dd_letter/EditDDLetter.vue')
  },
  {
    path: '/company/expression_of_interest/letters/regret/create/:job_id',
    name: 'CompanyExpressionOfInterestLetterRegretCreate',
    component: () => import('../../views/company/expression_of_interest/category/letters/regret_letter/CreateRegret.vue')
  },
  {
    path: '/company/expression_of_interest/letters/regret/edit/:job_id',
    name: 'CompanyExpressionOfInterestLetterRegretEdit',
    component: () => import('../../views/company/expression_of_interest/category/letters/regret_letter/EditRegretLetter.vue')
  },
  {
    path: '/company/expression_of_interest/zip/files/progress/:task_id/:section_id',
    name: 'CompanyExpressionOfInterestZipFiles',
    component: () => import('../../views/company/expression_of_interest/category/ZipFilesProgress.vue')
  },
  {
    path: '/company/expression_of_interest/cat/suppliers/progress/:prequal_id/:task_id/',
    name: 'CompanyExpressionOfInterestCatSuppliers',
    component: () => import('../../views/company/expression_of_interest/CatSuppliersProgress.vue')
  },
]

export default routes;